// extracted by mini-css-extract-plugin
export default {"google-button":"google_button_google-button__OpmnO"};